module.exports = __webpack_public_path__ + "static/media/promotionAlone.97c0b592.png";